import React from 'react'

interface IItemImageProps {
  ean: string
  slot?: string
}

export default function ItemImage({ ean, slot }: IItemImageProps) {
  const PLACEHOLDER_IMAGE = 'https://assets.icanet.se/image/upload/w_128,c_scale/e_sharpen:80/f_auto,q_auto:best,dpr_1.0/v1/togostoredashboard/placeholder.webp'
  
  return (
    <div slot={slot} className='min-w-[3em] min-h-[3em] max-w-[3em] max-h-[3em] flex items-center self-center justify-center'>
      <img
        src={`https://assets.icanet.se/image/upload/w_128,c_scale/e_sharpen:80/f_auto,q_auto:best,dpr_1.0/${ean}.webp`}
        className='max-w-[3em] max-h-[3em] select-none'
        onError={({ currentTarget }) => {
          currentTarget.onerror = null // prevents looping
          currentTarget.src = PLACEHOLDER_IMAGE
        }}
      />
    </div>
  )
}
